import * as React from 'react';
import { cn } from '@/lib/utils/cn';

interface SkipLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
}

/**
 * SkipLink Component
 * 
 * Provides keyboard users with a way to skip to main content,
 * improving navigation efficiency for screen reader users.
 */
const SkipLink = React.forwardRef<HTMLAnchorElement, SkipLinkProps>(
  ({ className, href, children, ...props }, ref) => {
    return (
      <a
        ref={ref}
        href={href}
        className={cn('skip-link', className)}
        {...props}
      >
        {children}
      </a>
    );
  }
);
SkipLink.displayName = 'SkipLink';

export { SkipLink };